module.exports = require("./gatsby/gatsby-browser");